const map = {
	"./0/favicon.ico": 8328,
	"./1/favicon.ico": 4741,
	"./10/favicon.ico": 4523,
	"./11/favicon.ico": 4230,
	"./12/favicon.ico": 1781,
	"./13/favicon.ico": 7032,
	"./14/favicon.ico": 3127,
	"./15/favicon.ico": 4450,
	"./16/favicon.ico": 3105,
	"./17/favicon.ico": 4452,
	"./18/favicon.ico": 531,
	"./19/favicon.ico": 8510,
	"./2/favicon.ico": 3078,
	"./20/favicon.ico": 2978,
	"./21/favicon.ico": 1991,
	"./3/favicon.ico": 9483,
	"./4/favicon.ico": 4676,
	"./5/favicon.ico": 8657,
	"./6/favicon.ico": 2162,
	"./7/favicon.ico": 9239,
	"./8/favicon.ico": 560,
	"./9/favicon.ico": 445
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4408;